interface WarningObjectType {
  message: string
  buttonText: string
  processButtonText: string
}

export default {
  namespaced: true,
  state: {
    isWarning: false,
    warningMessage: "",
    warningButtonText: "",
    warningProcessButtonText: "",
  },
  mutations: {
    SET_ISWARNING: (state: any, payload: boolean) => {
      state.isWarning = payload
    },
    SET_WARNING_MESSAGE: (state: any, payload: string) => {
      state.warningMessage = payload
    },
    SET_WARNING_BUTTON_TEXT: (state: any, payload: string) => {
      state.warningButtonText = payload
    },
    SET_WARNING_PROCESS_BUTTON_TEXT: (state: any, payload: string) => {
      state.warningProcessButtonText = payload
    },
  },
  actions: {
    openWarning: ({ commit }: any, payload: WarningObjectType) => {
      commit("SET_WARNING_MESSAGE", payload.message)
      commit("SET_WARNING_BUTTON_TEXT", payload.buttonText)
      commit("SET_WARNING_PROCESS_BUTTON_TEXT", payload.processButtonText)
      commit("SET_ISWARNING", true)
    },
    closeWarning: ({ commit }: any) => {
      commit("SET_ISWARNING", false)
    },
  },
}
